export interface MarkupAttachment {
  filename: string;
  path?: string;
}

export interface ParsedAttachmentMarkup {
  textContent: string;
  attachments: MarkupAttachment[];
}

const ATTACHMENTS_BLOCK_REGEX = /<attachments>([\s\S]*?)<\/attachments>/gi;
const ATTACHMENT_TAG_REGEX = /<attachment\s+([^>]+?)\s*\/?>/gi;
const ATTRIBUTE_REGEX = /(\w+)=["']([^"']*)["']/g;
const SYSTEM_CONTEXT_BLOCK_REGEX = /<systemContext>[\s\S]*?<\/systemContext>/gi;

/**
 * Extracts attachment metadata from a message string that contains
 * `<attachments>` markup and returns the cleaned text content.
 */
export const parseAttachmentMarkup = (content: string): ParsedAttachmentMarkup => {
  if (!content) {
    return { textContent: '', attachments: [] };
  }

  const attachments: MarkupAttachment[] = [];

  const cleaned = content.replace(ATTACHMENTS_BLOCK_REGEX, (blockMatch: string) => {
    let attachmentMatch: RegExpExecArray | null;

    while ((attachmentMatch = ATTACHMENT_TAG_REGEX.exec(blockMatch)) !== null) {
      const attributes = attachmentMatch[1];
      const attachment: MarkupAttachment = { filename: '' };

      let attributeMatch: RegExpExecArray | null;
      while ((attributeMatch = ATTRIBUTE_REGEX.exec(attributes)) !== null) {
        const name = attributeMatch[1].toLowerCase();
        const value = attributeMatch[2];
        if (name === 'filename') attachment.filename = value;
        else if (name === 'path') attachment.path = value;
      }
      ATTRIBUTE_REGEX.lastIndex = 0;

      if (attachment.filename) {
        attachments.push(attachment);
      }
    }

    ATTACHMENT_TAG_REGEX.lastIndex = 0;
    return '';
  });

  const textContent = cleaned
    .replace(SYSTEM_CONTEXT_BLOCK_REGEX, '')
    .trimEnd();

  return { textContent, attachments };
};
